<template>
  <page style="height: 100vh; overflow: hidden">
    <template v-if="isScan && cabinet && !isBtns">
      <div slot="nav" class="page-head-default">
        <img src="../assets/imgs/menu.png" alt="" @click="isMenuView = true" />
        {{ title }}
      </div>
    </template>
    <div>
      <div class="home-warp" v-if="isScan && cabinet && !isBtns">
        <div class="banner" :style="banner"></div>
        <div class="home-warp-main">
          <div class="home-warp-block"></div>
          <div class="home-warp-cont">
            <div class="home-warp-title">
              <img src="../assets/imgs/map.png" alt="" />
              <span>{{ cabinet.shopname }}</span>
            </div>
            <div class="home-warp-jifei">
              <span>{{ cabinet.currencyName }}{{ cabinet.jifei }}</span
              >/{{ cabinet.jifeiDanwei }}{{ i18n.minute }}
            </div>
            <div class="home-warp-row" style="color: #31B3FF;">{{ shopDesc }}</div>
            <div class="home-warp-row">
              <!-- <img src="../assets/imgs/icon_phone.png" alt="" /> -->
              {{ i18n.feature_1 }}
            </div>
            <div class="home-warp-row">
              <!-- <img src="../assets/imgs/icon_star.png" alt="" /> -->
              {{ i18n.feature_2 }}
            </div>
            <!-- <div class="home-warp-row">
              <img src="../assets/imgs/icon_tag.png" alt="">
              {{i18n.feature_3}}
            </div> -->
          </div>
          <div class="home-warp-btn">
            <!-- <div class="home-warp-btn" v-if="cabinet.chongzhi === 'Y'"> -->
            <!-- <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips1 }}</span>
            </div> -->
            <div
              class="btn"
              v-if="cabinet.yajintype === 0 && cabinet.yajin > 0"
              @click="onSubmit"
            >
              {{ i18n.preauth }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
            <div v-else class="btn" @click="onSubmit">
              {{ i18n.borrow }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
          </div>
          <!-- <div class="home-warp-btn" v-else>
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <!- <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div> ->
          </div> -->
        </div>
      </div>
      <div v-else class="home-download-warp">
        <div class="home-logo">
          <img src="@/assets/imgs/logo2.png" alt="">
        </div>
        <div class="home-bg">
          <img class="home-bg-img" src="@/assets/imgs/home_img.png" alt="">
          <div class="home-bg-title">
            Welcome to <span>BLITZ</span>
          </div>
          <div class="home-bg-foot">
            <div class="home-bg-btn" @click="onCode">
              <span>{{i18n.goborrow}}</span>
              <img src="@/assets/imgs/icon_right.png" alt="">
            </div>
          </div>
        </div>
        <div class="home-foot">
          <div class="download-tips"><span>Download</span> the App</div>
          <div class="home-btns">
            <div @click="onAppStore">
              <img src="../assets/imgs/icon_home_apple.png" alt="" />
              <span>App store</span>
            </div>
            <div @click="onGooglePlay">
              <img src="../assets/imgs/icon_home_play.png" alt="" />
              <span>Playstore</span>
            </div>
          </div>
        </div>
      </div>
      <popup-warp v-model="isMenuView" dialogTransition="slide-left">
        <menu-side @close="isMenuView = false"></menu-side>
      </popup-warp>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { PopupWarp } from "../components/popup"
import { MenuSide } from "../components/menu"
import { QR_CODE, ZH_CODE, ORDER_TEMP } from "../apis/cabinet"
import { USER_INFO, USER_CARD } from "../apis/user"

import { SAVED_CARD_TO_RENT } from "../apis/payment"

export default {
  components: {
    PopupWarp,
    MenuSide
  },
  computed: {
    ...mapState(["qrcode", "zhcode", "cabinet", "browser", "user", "system"]),
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    title() {
      return process.env.VUE_APP_NAME
    },
    code() {
      return this.qrcode || this.zhcode
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ""
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ""
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format({
        yajin: this.cabinet.priceStrategy.pDepositAmount,
        overtime: this.cabinet.priceStrategy.pOvertimeDay * 24,
        overtimeAmount: this.cabinet.priceStrategy.pOvertimeAmount,
        currencyName: this.cabinet.currencyName,
        fengding: this.cabinet.fengding
      })
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet)
    },
    homebg() {
      return `${process.env.VUE_APP_DOMAIN}/content/introduction1.png`
    },
    amount() {
      if (this.cabinet) {
        const { yajin, myyue, overtimeAmount } = this.cabinet
        let _amount = yajin.toFixed(2)
        if (yajin <= 0 && overtimeAmount <= 0) {
          _amount = (yajin - myyue).toFixed(2)
        }
        return _amount
      } else {
        return 0
      }
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      checked: true,
      adVisible: false,
      downloadApp: false,
      downType: "",
      cardList: [] // 支付的卡列表
    }
  },
  methods: {
    Download(str) {
      this.downloadApp = true
      this.downType = str
    },
    handleDown() {
      if (this.system === "ios") {
        this.onAppStore()
      } else {
        this.onGooglePlay()
      }
    },
    onScan() {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.isScan = true
            this.isBtns = false
            this.adVisible = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onSubmit() {
      this.$store.commit("wallet", null)
      let paymentWay = ""

      // yajin 押金金额  && overtimeAmount 超时金额
      const { yajin, overtimeAmount } = this.cabinet
      console.log(this.cabinet, yajin, overtimeAmount)
      // 余额租借 - 押金金额 = 0 && 超时金额 = 0
      if (yajin <= 0 && overtimeAmount <= 0) {
        return this.onBorrow()
      }

      //  是否有卡
      var _isUserCard = this.cardList.length > 0
      // 卡授权 - 押金金额 = 0 && 超时金额 > 0
      if (yajin <= 0 && overtimeAmount > 0) {
        paymentWay = "PAYMENT_CARD"
        if (_isUserCard) {
          return this.saveToRent()
        }
      }
      // 预授权 - 押金金额 > 0 && 超时金额 > 0
      if (yajin > 0 && overtimeAmount > 0) {
        paymentWay = "PAYMENT_PROPAY"
        // 保存卡 - 押金金额 < 超时金额  （必须绑卡）
        if (yajin < overtimeAmount) {
          paymentWay = "PAYMENT_SAVED_PROPAY"
        }
      }
      this.$router.push({
        path: "/confirm",
        query: {
          paymentWay,
          payType: "YJ",
          price: this.amount,
          cabinetID: this.cabinet.cabinetID,
          yaJinType: this.cabinet.yajintype
        }
      })
    },
    onBorrow() {
      this.$loading(true)
      this.$get(
        // `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            )
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          if (resp.user) {
            this.$store.commit("user", resp.user)
            this.onScan()
          } else {
            this.$store.commit("user", null)
          }
        },
        (error) => {
          this.$store.commit("user", null)
          console.log(error)
        }
      )
    },
    onAppStore() {
      console.log("11111")
      window.open(process.env.VUE_APP_APP_STORE)
      // window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      console.log("22222")
      window.open(process.env.VUE_APP_GOOGLE_PLAY)
      // window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    async onCode() {
      await this.getUserPayCard()
      this.isBtns = false
    },
    onEntrust() {
      console.log("test", process.env.VUE_APP_DOMAIN_NAME)
      window.location.href = `${process.env.VUE_APP_DOMAIN_NAME}/content/wxf_auth.html`
    },
    goNearby() {
      this.$router.push("./google_map")
    },
    setDocumentTitle(title) {
      document.title = title
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe")
        i.src = "/favicon.ico"
        i.style.display = "none"
        i.onload = function () {
          setTimeout(function () {
            i.remove()
          }, 9)
        }
        document.body.appendChild(i)
      }
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true)
      try {
        const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode)
        const { data = [] } = await this.$Request("get", USER_CARD, {
          qrcode,
          orderId: "",
          agentld: this.agentId
        })
        this.$loading(false)
        let cardList = []
        if (data && data.length) {
          cardList = data.map((item) => {
            return {
              phone: "all",
              label: item.pCardnumber,
              ...item.paymentConfig,
              ...item
            }
          })
          this.cardList = cardList
          return cardList
        }
      } catch (error) {
        this.$loading(false)
        return []
      }
    },
    saveToRent() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.out_trade_no) {
            this.$router.replace(
              `/result?&payMode=${this.payMode}&tradeNo=${resp.data.out_trade_no}`
            )
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    }
  },
  created() {
    this.isBtns = true;
    this.isScan = true;
    if (this.$route.query && this.$route.query.cabinetshow === "true") {
      this.isScan = true;
      this.isBtns = false;
      this.adVisible = true;
    }
  },
  mounted() {
    if (this.user || this.token) this.getUserPayCard();
  }
}
</script>

<style lang="less">
.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }

  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }

  &-block {
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }

  &-cont {
    padding: 0 48px;
  }

  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;

    span {
      font-size: 60px;
    }
  }

  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;

    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }

  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 48px;

    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }

  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.home-btns {
  display: flex;
  div {
    flex: 1;
    height: 82px;
    background: #fff;
    border-radius: 41px;
    margin: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    img {
      display: block;
      width: 46px;
      height: 46px;
      margin-right: 10px;
    }
  }
}

.downloaddark {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;

  .icondark {
    width: 40%;

    img {
      display: block;
      width: 90%;
    }

    img:last-child {
      margin-top: 20px;
    }
  }

  .next {
    width: 40%;
    font-family: "DIN Condensed Bold";
    font-size: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: #73d146;
    border-radius: 20px;
    padding: 0px 20px;

    .text {
      // line-height: 64px;
      display: block;
    }

    img {
      width: 64px;
      height: 64px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }
}

.go-code {
  text-align: center;
  color: #67c23a;
  text-decoration: underline;
  padding: 10px 0 30px;
}

.home-foot {
  position: fixed;
  bottom: 63px;
  left: 40px;
  right: 40px;
  .download-tips {
    font-size: 48px;
    color: #fff;
    text-align: center;
    padding-bottom: 25px;
    span {
      color: #00B6FF;
    }
  }
}

.borrow-wechat-zff {
  display: flex;
  justify-content: center;
  padding: 20px 0 4px;

  img {
    height: 34px;
  }
}

.home-checkbox {
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;

  .home-checkbox-text {
    color: #52ac7a;
  }

  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    color: #fff;
    width: 28px;
    height: 28px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #ddd;
  }

  input[type="checkbox"]:checked::after {
    content: "";
    background-color: #52ac7a;
    border-color: #52ac7a;
    background-color: #52ac7a;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 10px;
    width: 6px;
    height: 16px;
    border: solid white;
    border-width: 0 4px 4px 0;
    transform: rotate(45deg);
    z-index: 1;
  }
}

.home-mine {
  width: 90px;
  height: 60px;
  line-height: 30px;
  padding: 15px 0;
  font-size: 28px;
  text-align: center;
  position: fixed;
  right: 40px;
  bottom: 350px;
  z-index: 99;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 8px 24px 0 rgba(52, 125, 255, 0.32);
  // img {
  //   width: 100%;
  //   height: 100%;
  //   border-radius: 50%;
  // }
}
.home-download-warp {
  background-image: url('../assets/imgs/home_bj.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  .home-logo {
    padding-top: 65px;
    padding-left: 55px;
    img {
      width: 242px;
    }
  }
  .home-bg {
    position: relative;
    .home-bg-img {
      display: block;
      margin: 0 auto;
      // width: 640px;
      height: 70vh;
    }
    .home-bg-title {
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;
      font-size: 60px;
      font-weight: bold;
      span {
        color: #00B6FF;
      }
    }
    .home-bg-foot {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      .home-bg-btn {
        height: 80px;
        padding: 0 95px;
        border: 2px solid #00B6FF;
        border-radius: 40px;
        font-size: 30px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        box-shadow: 0 0 70px rgba(0, 182, 255, 0.4), inset 0 0 40px rgba(0, 182, 255, 0.4);
        img {
          width: 35px;
          height: 35px;
          display: block;
          margin: 0 0 0 18px;
        }
      }
    }

  }
}
</style>
